import * as React from 'react';

export type SeverityLevel = 'critical' | 'important' | 'moderate' | 'minor' | 'none' | 'undefined';

export interface SeverityLabelProps {
  severity: SeverityLevel;
  children?: React.ReactNode;
  className?: string;
}

const SEVERITY_TEXT: Record<SeverityLevel, string> = {
  critical: 'Critical',
  important: 'Important',
  moderate: 'Moderate',
  minor: 'Minor',
  none: 'None',
  undefined: 'Undefined',
};

/**
 * PatternFly severity (impact), not status (state).
 * Same badge craft as StatusLabel — dot + text, no outline.
 */
const SeverityLabel: React.FunctionComponent<SeverityLabelProps> = ({
  severity,
  children,
  className = '',
}) => (
  <span className={['app-status-label', `app-severity-label--${severity}`, className].filter(Boolean).join(' ')}>
    <span className="app-status-label__dot" aria-hidden="true" />
    <span className="app-status-label__text">{children ?? SEVERITY_TEXT[severity]}</span>
  </span>
);

export { SeverityLabel };
